// Compatibiliza reservas históricas imutáveis (0/1 por posição) com pedidos novos.
// Nunca infere produto por aproximação: nomes ambíguos impedem inclusão insegura.
export const productKey = name => String(name || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().replace(/\s+/g, ' ').toLowerCase();

export function groupHistoricalQuantities(historical = [], orders = [], products = []) {
  const groups = new Map();
  const catalog = new Map();
  for (const product of products) {
    const key = productKey(product.name);
    if (!catalog.has(key)) catalog.set(key, []);
    catalog.get(key).push(product);
  }
  for (const pos of historical) {
    const key = productKey(pos.product_name);
    if (!groups.has(key)) groups.set(key, {key, product_name:pos.product_name, positions:[], active:[], inactive:[], closed:[], historicalValue:0});
    const group = groups.get(key);
    group.positions.push(pos);
    if (pos.already_closed) {group.closed.push(pos);continue;}
    if (Number(pos.quantity) === 1) {
      group.active.push(pos);
      group.historicalValue += Number(pos.unit_price_brl || 0);
    } else group.inactive.push(pos);
  }
  return [...groups.values()].map(group => {
    const matches = catalog.get(group.key) || [];
    const product = matches.length === 1 ? matches[0] : null;
    const extras = product ? orders.filter(o=>o.product_id===product.id && o.sale_mode!=='box' && o.status==='open') : [];
    const extraQuantity = extras.reduce((sum,o)=>sum + Number(o.quantity||0),0);
    const extraValue = extras.reduce((sum,o)=>sum + Number(o.quantity||0)*Number(o.unit_price||0),0);
    return {...group,product,extras,extraQuantity,totalQuantity:group.active.length+extraQuantity,
      totalValue:group.historicalValue+extraValue,ambiguous:matches.length>1};
  });
}
